var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHermit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.54 396.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 438.87,
    y1: 90.72,
    x2: 339.38,
    y2: 228.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.86,
    y1: 373.51,
    x2: 382.28,
    y2: 373.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 339.38,
    y1: 228.6,
    x2: 382.28,
    y2: 373.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.86,
    y1: 244.68,
    x2: 100.86,
    y2: 373.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 205.06,
    y1: 244.5,
    x2: 100.86,
    y2: 244.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.67,
    y1: 22.67,
    x2: 100.86,
    y2: 244.68
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.38 367.28 108.09 377.37 107.1 394.03 97.01 380.74 80.34 379.75 93.64 369.65 94.63 352.99 104.72 366.29 121.38 367.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "400.86 384.24 384.4 381.43 371.56 392.09 374.37 375.63 363.71 362.79 380.16 365.6 393.01 354.94 390.19 371.39 400.86 384.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "360.57 231.97 344.2 235.23 336.02 249.78 332.75 233.41 318.2 225.23 334.57 221.97 342.75 207.42 346.02 223.79 360.57 231.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.03 259.84 100.86 252.87 85.7 259.84 92.67 244.68 85.7 229.51 100.86 236.49 116.03 229.51 109.05 244.68 116.03 259.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.23 259.66 205.06 252.69 189.9 259.66 196.87 244.5 189.9 229.33 205.06 236.3 220.23 229.33 213.26 244.5 220.23 259.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "458.85 82.93 446.37 94.01 446.66 110.7 435.58 98.22 418.89 98.51 431.37 87.43 431.08 70.74 442.16 83.22 458.85 82.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.65 14.88 30.17 25.96 30.46 42.65 19.37 30.17 2.68 30.46 15.17 19.37 14.88 2.68 25.96 15.17 42.65 14.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "282.36 73.89 270.57 64.15 263.07 77.48 263.33 62.2 248.24 64.65 260.36 55.32 249.03 45.05 263.88 48.71 264.84 33.45 271.24 47.33 283.78 38.57 276.91 52.24 291.57 56.57 276.61 59.72 282.36 73.89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHermit);
export default __webpack_public_path__ + "static/media/Hermit.ae3fcf0d9a576c4c5ca91ade8a598a8c.svg";
export { ForwardRef as ReactComponent };